import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class LinkManagerService {

  constructor(private platform: Platform) { }

  isMobileWeb() {
    // console.log(this.platform.is('mobile'), this.platform.is('hybrid'));
    //return this.platform.is('mobile') && !this.platform.is('hybrid');

    // Para que nunca entre y mande a instalal la App
    return false;
  }

  generateDinamicLink(deepPath) {
    const iosBundleId = 'co.miradores.med';
    const appStoreId = '6449554555';  // Reemplaza con tu ID de la App Store
    // return `https://med.miradores.co/${deepPath}`;
    return `https://miradores.page.link/?link=https://med.miradores.co/${deepPath}&apn=co.miradores.med&afl=https://play.google.com/store/apps/details?id=co.miradores.med&ibi=${iosBundleId}&isi=${appStoreId}&efr=1&`;

  }




}
